/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:20:28
 * @Description:模拟用户登陆
 */
import { genResBody } from "../tool.js";

export default {
	"post|/auth/login": (option) => {
		const { password, username } = JSON.parse(option.body);
		if (username === "admin" && password === "123456") {
			return genResBody({
				token: "token",
			});
		} else {
			return genResBody(null, 401, "用户名或密码错误");
		}
	},
};
